export default {
    path : "warehouse-item-success",
    name : "warehouse-item-success",
    meta : {
        title : "全体成功项目"
    },
    component: () => import('@/pages/warehouse/success/Index'),
    redirect: {
        name : "warehouse-item-success-whole"
    },
    children: [
        {
            path: 'all',
            name: 'warehouse-item-success-whole',
            meta: {
                title: '仓库项目-列表页'
            },
            component: () => import('@/pages/itemCommon/List'),
        },
        {
            path: 'recent',
            name: 'warehouse-item-success-recent',
            meta: {
                title: '仓库项目-列表页'
            },
            component: () => import('@/pages/itemCommon/List'),
        },
        {
            path: 'atme',
            name: 'warehouse-item-success-atme',
            meta: {
                title: '仓库项目-列表页'
            },
            component: () => import('@/pages/itemCommon/List'),
        },
        {
            path: 'meat',
            name: 'warehouse-item-success-meat',
            meta: {
                title: '仓库项目-列表页'
            },
            component: () => import('@/pages/itemCommon/List'),
        },
        {
            path: 'reply',
            name: 'warehouse-item-success-reply',
            meta: {
                title: '仓库项目-列表页'
            },
            component: () => import('@/pages/itemCommon/List'),
        },
        {
            path: 'search',
            name: 'warehouse-item-success-search',
            meta: {
                title: '仓库项目-列表页'
            },
            component: () => import('@/pages/itemCommon/List'),
        },
    ]
}


// WEBPACK FOOTER //
// ./src/router/warehouse/successitem/index.js